var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera-original-wordmark-a",
    gradientTransform: "matrix(0 43.04975 -45.37783 0 19.508 .808)",
    gradientUnits: "userSpaceOnUse",
    x1: "0",
    x2: "1",
    y1: "0",
    y2: "0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".614",
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera-original-wordmark-b",
    gradientTransform: "matrix(0 38.07518 -40.13424 0 31.263 3.346)",
    gradientUnits: "userSpaceOnUse",
    x1: "0",
    x2: "1",
    y1: "0",
    y2: "0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7",
    stopColor: "#FF4B4B"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M23.41.086C10.48.086 0 10.027 0 22.297c0 11.91 9.883 21.629 22.297 22.18.371.016.742.027 1.113.027 5.996 0 11.461-2.137 15.602-5.652a17.54 17.54 0 01-9.379 2.723c-5.578 0-10.57-2.625-13.926-6.766-2.59-2.898-4.266-7.184-4.383-11.988V21.77c.117-4.809 1.793-9.094 4.379-11.992 3.359-4.137 8.352-6.758 13.93-6.758 3.43 0 6.637.988 9.383 2.715C34.891 2.238 29.461.109 23.5.086h-.09zm0 0",
    fill: "url(#opera-original-wordmark-a)",
    transform: "translate(0 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.707 9.777c2.148-2.406 4.922-3.859 7.953-3.859C30.477 5.918 36 13.25 36 22.297c0 9.039-5.527 16.371-12.34 16.371-3.031 0-5.805-1.449-7.953-3.855 3.355 4.141 8.348 6.762 13.926 6.762a17.53 17.53 0 009.379-2.723c4.793-4.066 7.813-9.973 7.813-16.555s-3.02-12.492-7.809-16.559a17.52 17.52 0 00-9.383-2.719c-5.574 0-10.57 2.621-13.926 6.758",
    fill: "url(#opera-original-wordmark-b)",
    transform: "translate(0 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.078 73.496c-2.953 0-5.355-2.508-5.355-5.586s2.402-5.586 5.355-5.586 5.352 2.512 5.352 5.586-2.402 5.586-5.352 5.586m0-12.715a6.5 6.5 0 00-5.07 2.391v-2.066H76.36v17.996h1.648v-6.457a6.48 6.48 0 005.07 2.398c3.852 0 6.984-3.199 6.984-7.133s-3.133-7.129-6.984-7.129M64.691 73.926c-4.648 0-8.43-3.793-8.43-8.453s3.781-8.453 8.43-8.453 8.43 3.793 8.43 8.453-3.781 8.453-8.43 8.453m0-18.402c-5.516 0-10.004 4.461-10.004 9.949s4.488 9.949 10.004 9.949 10.004-4.465 10.004-9.949-4.488-9.949-10.004-9.949m48.473 5.312a3.89 3.89 0 00-1.609.414c-1.055.535-1.785 1.348-2.254 2.387l-.035.078-.016-2.523h-1.652v13.48h1.656v-7.074c0-.996.164-1.805.508-2.59.316-.73.762-1.379 1.398-1.895a3.21 3.21 0 012.594-.727l.48.094c.094-.449.32-1.02.414-1.469a5.352 5.352 0 00-1.484-.176m-14.637 1.509c2.918 0 4.957 1.871 5.301 4.723H93.246c.398-2.668 2.613-4.723 5.281-4.723m0-1.543c-3.852 0-6.984 3.203-6.984 7.133s3.133 7.129 6.984 7.129c2.758 0 5.145-1.633 6.281-4.004l-1.422-.789c-.852 1.918-2.707 3.246-4.859 3.246-2.789 0-5.082-2.238-5.328-5.082h12.297l.02-.5c0-4.203-2.875-7.133-6.988-7.133m22.753 12.695c-2.953 0-5.355-2.508-5.355-5.586s2.402-5.586 5.355-5.586 5.355 2.512 5.355 5.586-2.402 5.586-5.355 5.586m5.07-12.391v2.066a6.5 6.5 0 00-5.07-2.391c-3.852 0-6.984 3.199-6.984 7.129s3.133 7.133 6.984 7.133a6.485 6.485 0 005.07-2.398v2.031H128v-13.57zm0 0"
  }));
};